import { api } from './client.js';

const unwrap = (resp) => resp.data?.data;

export const wikiApi = {
  // Spaces
  listSpaces: () => api.get('/wiki/spaces').then(unwrap),
  getSpace: (key) => api.get(`/wiki/spaces/${key}`).then(unwrap),
  createSpace: (payload) => api.post('/wiki/spaces', payload).then(unwrap),
  updateSpace: (key, payload) => api.put(`/wiki/spaces/${key}`, payload).then(unwrap),
  archiveSpace: (key) => api.delete(`/wiki/spaces/${key}`).then(unwrap),

  // Pages
  createPage: (spaceKey, payload) => api.post(`/wiki/spaces/${spaceKey}/pages`, payload).then(unwrap),
  getPageBySlug: (spaceKey, slug) => api.get(`/wiki/spaces/${spaceKey}/pages/by-slug/${slug}`).then(unwrap),
  getPage: (id) => api.get(`/wiki/pages/${id}`).then(unwrap),
  updatePage: (id, payload) => api.put(`/wiki/pages/${id}`, payload).then(unwrap),
  archivePage: (id) => api.delete(`/wiki/pages/${id}`).then(unwrap),
  movePage: (id, payload) => api.put(`/wiki/pages/${id}/move`, payload).then(unwrap),
  duplicatePage: (id) => api.post(`/wiki/pages/${id}/duplicate`).then(unwrap),

  // Versions
  listVersions: (id) => api.get(`/wiki/pages/${id}/versions`).then(unwrap),
  getVersion: (id, verNo) => api.get(`/wiki/pages/${id}/versions/${verNo}`).then(unwrap),
  restoreVersion: (id, verNo) => api.post(`/wiki/pages/${id}/versions/${verNo}/restore`).then(unwrap),

  // Comments
  listComments: (id) => api.get(`/wiki/pages/${id}/comments`).then(unwrap),
  createComment: (id, payload) => api.post(`/wiki/pages/${id}/comments`, payload).then(unwrap),
  updateComment: (id, payload) => api.put(`/wiki/comments/${id}`, payload).then(unwrap),
  deleteComment: (id) => api.delete(`/wiki/comments/${id}`).then(unwrap),
  resolveComment: (id) => api.post(`/wiki/comments/${id}/resolve`).then(unwrap),

  // Reactions
  listReactions: (id) => api.get(`/wiki/pages/${id}/reactions`).then(unwrap),
  addReaction: (id, emoji) => api.post(`/wiki/pages/${id}/reactions`, { emoji }).then(unwrap),
  removeReaction: (id, emoji) => api.delete(`/wiki/pages/${id}/reactions`, { data: { emoji } }).then(unwrap),

  // Watchers
  watch: (id) => api.post(`/wiki/pages/${id}/watch`).then(unwrap),
  unwatch: (id) => api.delete(`/wiki/pages/${id}/watch`).then(unwrap),

  // Backlinks
  listBacklinks: (id) => api.get(`/wiki/pages/${id}/backlinks`).then(unwrap),

  // Search
  search: (params) => api.get('/wiki/search', { params }).then(unwrap),

  // Templates
  listTemplates: (params) => api.get('/wiki/templates', { params }).then(unwrap),
  createTemplate: (payload) => api.post('/wiki/templates', payload).then(unwrap),
  deleteTemplate: (id) => api.delete(`/wiki/templates/${id}`).then(unwrap),
  useTemplate: (id) => api.post(`/wiki/templates/${id}/use`).then(unwrap),
};
